<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-text>
                    <v-row class="text-center">
                        <v-col cols="12" md="3" sm="6" xs="12">
                            <div class="mb-2">
                                <v-card
                                    style="
                    border: solid 1px #3a33e8;
                    border-left: solid 10px #3a33e8;
                  "
                                >
                                    <v-card-title primary-title class="justify-center">
                                        {{ finance.balanceDay }}
                                    </v-card-title>
                                    <v-card-text> Dia de Fechamento</v-card-text>
                                </v-card>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card
                                style="
                  border: solid 1px #008000;
                  border-left: solid 10px #008000;
                "
                            >
                                <v-card-title primary-title class="justify-center">
                                    {{ finance.balanceReleased | money }}
                                </v-card-title>
                                <v-card-text> Saldo Liberado</v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card
                                class="mb-2 text-center"
                                style="
                  border: solid 1px #008000;
                  border-left: solid 10px #008000;
                "
                            >
                                <v-card-title primary-title class="justify-center">
                                    {{ finance.balanceToReleased | money }}
                                </v-card-title>
                                <v-card-text> Saldo a Liberar</v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card
                                class="mb-2 text-center"
                                style="
                  border: solid 1px #3d1159;
                  border-left: solid 10px #3d1159;
                "
                            >
                                <v-card-title primary-title class="justify-center">
                                    {{ finance.balanceTotal | money }}
                                </v-card-title>
                                <v-card-text> Saldo Total</v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-divider></v-divider>

            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="12" md="4" xl="4" sm="4" class="mr-0">
                            <v-icon left>mdi-cash-check</v-icon>
                            Resgatar Saldo
                        </v-col>

                    </v-row>
                    <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text>
                    <v-form
                        ref="formBalanceRescue"
                        v-model="formIsValid"
                        v-on:submit.prevent="dialogRescueBalanceDialog"
                    >
                        <v-row>
                            <v-col cols="12" md="4" sm="6" xs="12">
                                <number-input
                                    v-model="balanceRequestValue"
                                    outlined
                                    label="Valor de Resgate"
                                    placeholder="Digite o Valor que Deseja Liberar"
                                    :rules="[rescueRules]"
                                    :options="optionsMoney"
                                    required
                                    dense
                                    append-icon="mdi-cash-check"
                                ></number-input>
                            </v-col>

                            <v-col cols="12" md="2" sm="6" xs="12">
                                <v-btn
                                    class="btn-new"
                                    type="submit"
                                    :disabled="btnBalanceCheck"
                                >
                                    <v-icon left>mdi-cash-check</v-icon>
                                    Resgatar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="6" xl="6" sm="4">
                                <v-alert dense text color="blue" style="font-size: 12px">
                                    <v-btn color="#ff8c00" icon @click="dialogRescue = true">
                                        <v-icon>mdi-help-circle</v-icon>
                                    </v-btn>
                                    Clique aqui para saber como funciona o resgate
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row v-show="balanceRequest.valueTotal">
                        <v-col cols="12" md="3" sm="6" xs="6" class="text-center">
                            <v-card
                                style="
                  border: solid 1px #3a33e8;
                  border-left: solid 5px #3a33e8;
                "
                            >
                                <v-card-title class="justify-center text-body-1">
                                    {{ balanceRequest.valueReleased | money }}
                                </v-card-title>
                                <v-card-text class="justify-center">
                                    <strong>Valor Liberado </strong>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="6" class="text-center">
                            <v-card
                                style="
                  border: solid 1px #008000;
                  border-left: solid 5px #008000;
                "
                            >
                                <v-card-title class="justify-center text-body-1">
                                    {{ balanceRequest.valueToReleased | money }}
                                </v-card-title>
                                <v-card-text class="justify-center">
                                    <strong>Valor de Antecipação</strong>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="6" class="text-center">
                            <v-card
                                style="
                  border: solid 1px #008000;
                  border-left: solid 5px #008000;
                "
                            >
                                <v-card-title class="justify-center text-body-1">
                                    <!--                                                    {{ balanceRequest.valueRate | money }}-->
                                    {{ finance.rateAnticipation }} %
                                </v-card-title>
                                <v-card-text class="justify-center">
                                    <strong>Taxa de Antecipação </strong>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="3" sm="6" xs="6" class="text-center">
                            <v-card
                                style="border: solid 1px #3d1159;border-left: solid 5px #3d1159;"
                            >
                                <v-card-title class="justify-center text-body-1">
                                    {{ balanceRequest.valueTotal | money }}
                                </v-card-title>
                                <v-card-text class="justify-center">
                                    <!--                                                    <strong>Valor de Resgate</strong>-->
                                    <strong>Valor Líquido do Resgate</strong>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-divider></v-divider>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-bank</v-icon>
                    Dados Bancários
                    <v-spacer></v-spacer>
                    <v-btn color="#3D1159" dark @click="dialogBankAccount = true">
                        <v-icon left>mdi-bank-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col
                            cols="12"
                            md="4"
                            sm="6"
                            xs="12"
                            xl="4"
                            v-for="(bank, bIndex) in bankAccounts"
                            :key="bIndex + '_bank'"
                        >
                            <v-card
                                class="fill-height pa-1"
                                style="
                  border: solid 1px #3d1159;
                  border-left: solid 5px #3d1159;
                "
                            >
                                <v-row>
                                    <v-col cols="12" md="9" sm="9" xs="9">
                                        <v-card-text v-show="bank.account">
                                            <v-row>
                                                <v-col md="12">
                                                    <v-icon left>mdi-bank</v-icon>
                                                    <strong> Banco:</strong> {{ bank.bank }}
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col md="12">
                                                    <v-icon left>mdi-domain</v-icon>
                                                    <strong>Agência:</strong> {{ bank.agency }}
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col md="12">
                                                    <v-icon left>mdi-account-cash</v-icon>
                                                    <strong>Conta:</strong> {{ bank.account }}
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <v-card-text v-show="bank.chavePIX">
                                            <strong>
                                                <v-icon left>mdi-key</v-icon>
                                                Chave PIX:</strong>
                                            {{ bank.chavePIX }}
                                        </v-card-text>
                                    </v-col>
                                    <v-col cols="12" md="3" sm="3" xs="3">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    icon
                                                    class="btn-lyndus"
                                                    @click="setDefaultBank(bank.id, bIndex)"
                                                    v-on="on"
                                                >
                                                    <v-icon v-show="!bank.default"
                                                    >mdi-heart-outline
                                                    </v-icon>
                                                    <v-icon v-show="bank.default">mdi-heart</v-icon>
                                                </v-btn>
                                            </template>
                                            <span v-show="!bank.default">Definir</span
                                            ><span> Conta Principal</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    icon
                                                    class="btn-del"
                                                    v-on="on"
                                                    @click="removeBankDialog(bank.id, bIndex)"
                                                >
                                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Remover</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-dialog v-model="dialogBalance" persistent max-width="700px">
                <v-card>
                    <v-form
                        ref="formBalance"
                        v-model="formIsValid"
                        v-on:submit.prevent="submitBalance()"
                    >
                        <v-card-title>
                            <span class="text-h5">Liberação de Saldo</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="7" sm="7" md="7">
                                        <number-input
                                            outlined
                                            label="Valor"
                                            placeholder="Digite o Valor que Deseja Liberar"
                                            :rules="textRules"
                                            :options="optionsMoney"
                                            required
                                        ></number-input>
                                    </v-col>
                                    <v-col cols="5" sm="5" md="5" class="text-right">
                                        <v-btn
                                            color="#3D1159"
                                            dark
                                            large
                                            @click="dialogBalance = true"
                                        >
                                            <v-icon left>mdi-cash-check</v-icon>
                                            Liberar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="7" sm="7" md="7">
                                        <strong>Saldo Liberado</strong> - R$ 13.000,00
                                        <strong>+</strong>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="7" sm="7" md="7">
                                        <strong>Saldo a Liberar</strong> - R$ 2.000,00
                                        <strong>-</strong>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="7" sm="7" md="7">
                                        <strong
                                        >Taxa de Antecipação de
                                            {{ finance.rateAnticipation }}%</strong
                                        >
                                        - R$ 1.880,00
                                        <strong>=</strong>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="7" sm="7" md="7">
                                        <strong>Valor de Resgate</strong> - R$ 14.880,00
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark color="error" @click="closeBalance()">
                                Cancelar
                            </v-btn>
                            <v-btn color="success" dark type="submit"> Salvar</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogRescue" max-width="700px">
                <v-card>
                    <v-card-title class="text-center text-h5 justify-center">
                        Como Funciona o Resgate
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialogRescue = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <p>
                            <strong>Importante:</strong> O valor solicitado para resgate será
                            creditado no prazo de <strong>1 dia útil</strong> na conta
                            corrente cadastrada abaixo, mas desde que a solicitação seja
                            realizada até às <strong>16 horas.</strong>
                        </p>
                        <p>
                            <strong>A Lyndus faz bem para o teu negócio!</strong> O resgate de
                            valores do teu Saldo Liberado não tem nenhum custo.
                            <strong>É taxa ZERO!</strong>
                        </p>
                        <p>
                            Mas caso precise de um reforço, também poderá utilizar o valor
                            total ou parcial do teu
                            <strong>Saldo a Liberar</strong> fazendo uma antecipação.
                        </p>
                        <p>
                            <strong>Funciona assim:</strong> Se o valor que você quiser
                            resgatar ultrapassar o valor do teu
                            <strong>Saldo Liberado</strong>, mas for igual ou menor do que o
                            teu <strong>Saldo Total</strong>, somente sobre o valor que você
                            precisou utilizar do <strong>Saldo a Liberar</strong> haverá a
                            cobrança de uma taxa de antecipação. Faça uma simulação digitando
                            ao lado o valor que você precisa e veja abaixo o
                            <strong>Valor Líquido do Resgate</strong> que será creditado. Se
                            estiver de acordo, é só clicar em <strong>RESGATAR SALDO.</strong>
                        </p>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogBankAccount" persistent max-width="700px">
                <v-card>
                    <v-form
                        ref="formBankAccount"
                        v-model="formIsValid"
                        v-on:submit.prevent="submitBankAccount()"
                    >
                        <v-card-title>
                            <span class="text-h5">Adicionar Conta Bancária</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col sm="4" md="12">
                                        <v-autocomplete
                                            v-model="bankAccount.bank"
                                            outlined
                                            :items="localBanks"
                                            :search-input.sync="search"
                                            item-text="value"
                                            hide-no-data
                                            label="Selecione seu banco"
                                            :rules="[bankRulesValid]"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="4" md="6">
                                        <v-text-field
                                            v-model="bankAccount.agency"
                                            outlined
                                            label="Agência"
                                            placeholder="Informe sua agência"
                                            v-mask="['####', '####-#', '####-##']"
                                            :rules="[bankRulesValid]"
                                            append-icon="mdi-domain"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="4" md="6">
                                        <v-text-field
                                            v-model="bankAccount.account"
                                            outlined
                                            label="Conta"
                                            placeholder="Digita a sua conta bancária con digito"
                                            :rules="[bankRulesValid]"
                                            hint="Ex: 12345-6, 12345-X, 123456-7"
                                            append-icon="mdi-account-cash"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col> Ou cadastre a chave do PIX</v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="12" md="12">
                                        <v-text-field
                                            v-model="bankAccount.chavePIX"
                                            outlined
                                            label="Chave PIX"
                                            placeholder="Digite sua chave do PIX"
                                            :rules="[pixRulesValid]"
                                            append-icon="mdi-key"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark class="btn-cancel" @click="closeBankAccount()">
                                <v-icon left>mdi-close</v-icon>
                                Cancelar
                            </v-btn>
                            <v-btn class="btn-save" dark type="submit">
                                <v-icon left>mdi-check</v-icon>
                                Salvar
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="dialogRescueBalance"
                persistent
                max-width="500px"
                width="50%"
            >
                <v-card>
                    <v-card-title class="text-h5">
                        Confirmar o resgate de {{ balanceRequest.valueTotal | money }} ?
                    </v-card-title>
                    <v-card-text>
                        <v-select
                            :items="bankAccounts"
                            label="Conta de Resgate"
                            v-model="balanceRequest.bankID"
                            item-value="id"
                            outlined
                        >
                            <template slot="selection" slot-scope="data">
                <span v-show="data.item.account">
                  {{ data.item.bank }}
                  <strong>AG:</strong> {{ data.item.agency }}
                  <strong>CC:</strong>{{ data.item.account }}
                </span>
                                <span v-show="data.item.chavePIX">
                  <strong>PIX:</strong>&nbsp; {{ data.item.chavePIX }}
                </span>
                            </template>
                            <template slot="item" slot-scope="data">
                <span v-show="data.item.account">
                  {{ data.item.bank }}
                  <strong>AG:</strong> {{ data.item.agency }}
                  <strong>CC:</strong>{{ data.item.account }}
                </span>
                                <span v-show="data.item.chavePIX">
                  <strong>PIX:</strong>&nbsp; {{ data.item.chavePIX }}
                </span>
                            </template>
                        </v-select>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn class="btn-cancel" dark @click="dialogRescueBalance = false">
                            <v-icon left>mdi-close</v-icon>
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="btn-save" @click="rescueBalance">
                            <v-icon left>mdi-check</v-icon>
                            Confirmar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
import store from "@/store";
import NumberInput from "@/components/NumberInput";

import {banks} from "@/common/banks.list";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";

import {
    BANK_ACCOUNT_CREATE,
    BANK_ACCOUNT_DEFAULT,
    BANK_ACCOUNT_DELETE,
    BANK_ACCOUNTS_GET,
    FINANCE_CREATE,
    FINANCE_GET,
    FINANCE_SEARCH,
} from "@/store/actions/financial.type";
import {
    FINANCIAL_RESET_STATE,
    REMOVE_BANK_ACCOUNT,
    SET_BANK_ACCOUNTS_DEFAULT,
    SET_FINANCE_PAGINATION,
} from "@/store/mutations/financial.type";

export default {
    name: "financial",
    directives: {mask},
    components: {NumberInput},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(FINANCIAL_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.commit(FINANCIAL_RESET_STATE);
        await store.dispatch(BANK_ACCOUNTS_GET);
        await store.dispatch(FINANCE_GET);

        return next();
    },
    data: () => ({
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        selected: [],

        tab: null,
        bankAccountIndex: null,
        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0,
        },

        formIsValid: false,
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2,
        },
        active: false,
        btnBalanceCheck: true,

        dialogRescueBalance: false,
        dialogBalance: false,
        dialogBankAccount: false,

        dialogBankRemove: false,

        dialogRescue: false,

        socialEdit: false,
        updateLogo: null,

        social: {
            socialID: 0,
            url: "",
        },

        balance: {
            socialID: 0,
            url: "",
        },
        subtitle: {
            socialID: 0,
            url: "",
        },

        pixRules: [
            (v) =>
                (!!v &&
                    !!this.bankAccount.bank &&
                    this.bankAccount.agency &&
                    this.bankAccount.account) ||
                "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
    }),

    methods: {
        rescueRules(v) {
            let n = parseFloat(v.replace(".", "").replace(",", "."));
            if (isNaN(n)) return "Informe um valor válido ";

            if (n < 1) return "O Valor Mínimo é de R$ 1,00";

            if (this.finance.balanceTotal < n)
                return "O Valor informado é maior que o Saldo Total";

            return true;
        },
        bankRulesValid(v) {
            if (!this.bankAccount.chavePIX) {
                return !!v || "Este campo é obrigatório";
            }
            return true;
        },
        pixRulesValid(v) {
            if (
                !this.bankAccount.bank &&
                !this.bankAccount.agency &&
                !this.bankAccount.account
            ) {
                return !!v || "Este campo é obrigatório";
            }
            return true;
        },

        querySelections(v) {
            this.localBanks = banks.filter((e) => {
                return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
            });
        },

        removeBankDialog(id, index) {
            this.dialogBankRemove = true;
            this.bankAccount.id = id;
            this.bankAccountIndex = index;
        },
        dialogRescueBalanceDialog() {
            this.dialogRescueBalance = true;
            for (let i = 0; i < this.bankAccounts.length; i++) {
                if (this.bankAccounts[i].default) {
                    this.balanceRequest.bankID = this.bankAccounts[i].id;
                    return;
                }
            }
        },
        loadExtract() {
            this.buscar();
        },
        async buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options;

            store.commit(SET_FINANCE_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0],
            });
            await store.dispatch(FINANCE_SEARCH);
        },
        async rescueBalance() {
            this.dialogRescueBalance = false;

            await this.$store
                .dispatch(FINANCE_CREATE, this.balanceRequest)
                .then((response) => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";

                    this.$refs.formBalanceRescue.reset();
                    this.$router.push({
                        name: "financialView",
                        params: {id: response.data.id},
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = "Erro ao salvar: " + response.data.message;
                    }
                });
        },
        async submitBankAccount() {
            if (this.$refs.formBankAccount.validate()) {
                this.$store.commit(CHANGE_PROGRESS, true);

                await this.$store
                    .dispatch(BANK_ACCOUNT_CREATE, this.bankAccount)
                    .then(async () => {
                        this.$store.commit(CHANGE_PROGRESS, false);

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        await store.dispatch(BANK_ACCOUNTS_GET);

                        this.$refs.formBankAccount.resetValidation();
                        this.$refs.formBankAccount.reset();

                        this.dialogBankAccount = false;
                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false);
                        this.dialogBankAccount = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar dados bancários";
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro ao salvar dados bancários: " + response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
        async removeBank() {
            await this.$store
                .dispatch(BANK_ACCOUNT_DELETE, this.bankAccount.id)
                .then(async () => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Removido com sucesso";

                    await store.commit(REMOVE_BANK_ACCOUNT, this.bankAccountIndex);
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao remover dados bancários";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro ao remover dados bancários: " + response.data.message;
                    }
                });
            this.dialogBankRemove = false;
            this.bankAccountIndex = null;
        },

        async setDefaultBank(id, index) {
            await this.$store
                .dispatch(BANK_ACCOUNT_DEFAULT, id)
                .then(async () => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Alterado com sucesso";

                    await store.commit(SET_BANK_ACCOUNTS_DEFAULT, index);
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao alterar";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = "Erro ao alterar: " + response.data.message;
                    }
                });
        },

        //Dialog Balance - Botão Liberar Saldo

        closeBalance() {
            this.$refs.formBalance.resetValidation();
            this.socialEdit = false;
            this.dialogBalance = false;
            this.social.socialID = null;
            this.social.url = "";
        },

        //Dialog Bank Account - Botão Adicionar (Conta)
        closeBankAccount() {
            this.$refs.formBankAccount.resetValidation();
            this.socialEdit = false;
            this.dialogBankAccount = false;
            this.social.socialID = null;
            this.social.url = "";
        },
    },

    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val);
        },
        balanceRequestValue(val) {
            // this.finance.balanceReleased = 500
            // this.finance.balanceToReleased = 500
            // this.finance.balanceTotal = 1000

            this.balanceRequest.valueReleased = 0;
            this.balanceRequest.valueToReleased = 0;
            this.balanceRequest.valueTotal = 0;
            this.balanceRequest.valueRate = 0;
            this.balanceRequest.value = this.balanceRequestValue;

            if (this.finance.balanceTotal < val || val < 1) {
                this.btnBalanceCheck = true;
                return;
            } else if (this.finance.balanceReleased >= val) {
                this.balanceRequest.valueReleased =
                    this.finance.balanceReleased - (this.finance.balanceReleased - val);
                this.balanceRequest.valueTotal =
                    this.balanceRequest.valueReleased +
                    this.balanceRequest.valueToReleased -
                    this.balanceRequest.valueRate;
            } else {
                this.balanceRequest.valueReleased = this.finance.balanceReleased;

                let rest = val - this.balanceRequest.valueReleased;

                if (this.finance.balanceToReleased >= rest) {
                    this.balanceRequest.valueToReleased =
                        this.finance.balanceToReleased -
                        (this.finance.balanceToReleased - rest);
                    this.balanceRequest.valueRate =
                        this.balanceRequest.valueToReleased *
                        (this.finance.rateAnticipation / 100);
                    this.balanceRequest.valueTotal =
                        this.balanceRequest.valueReleased +
                        this.balanceRequest.valueToReleased -
                        this.balanceRequest.valueRate;
                }
            }
            this.btnBalanceCheck = false;
        },

        // options: {
        //     handler() {
        //         this.buscar()
        //     },
        //     deep: true,
        // },
    },
    computed: {
        ...mapGetters([
            "snackbar",
            "bankAccount",
            "bankAccounts",
            "finance",
            "finances",
            "financePagination",
        ]),
    },
};
</script>